import { useDblIntl } from "@/pages/datalab/utils/utils";
import React from "react";
import { Button, Modal } from "tea-component";
import { getIsTemplatePageFn } from "../../CreateReport/utils";

const DeleteModal = (props: any) => {
  const { closeFunc, deletedFunc, deleteRecord } = props;
  const { dblFormatMessage, commonFormatMessage } = useDblIntl("myAnalysis");
  const messageTitle = getIsTemplatePageFn(deleteRecord?.category) ? deleteRecord?.template_title : deleteRecord?.dashboard_title;
  return <>
    <Modal
      visible={true}
      onClose={closeFunc}
    >
      <Modal.Body className="modal-context">
        <Modal.Message
          message={dblFormatMessage("sure_to_delete_dashboard_title")}
          description={dblFormatMessage("sure_to_delete_chart_message", { name: <span className="dbl_text-strong">{messageTitle}</span> })}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="primary"
          onClick={() => {
            closeFunc();
            deletedFunc();
          }}
        >
          {commonFormatMessage("confirm")}
        </Button>
        <Button
          type="weak"
          onClick={() => {
            closeFunc();
          }}
        >
          {commonFormatMessage("cancel")}
        </Button>
      </Modal.Footer>
    </Modal>
  </>;

};

export default DeleteModal;